export const tools = [
  {
    imageUrl: "https://cdn.worldvectorlogo.com/logos/visual-studio-code-1.svg",
    imageAlt: "Visual Studio Code",
    overlayColor: "overlay2 cyan lighten-4",
    overlayDesc: "My favourite text editor!",
  },
  {
    imageUrl: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
    imageAlt: "Git",
    overlayColor: "overlay2 green lighten-4",
    overlayDesc: ` I still remember first learning to use Git in first year at a
    software development event where I was super baffled. Now I
    can't live without it (as all software devs feel).`,
  },
  {
    imageUrl: "https://pytorch.org/assets/images/pytorch-logo.png",
    imageAlt: "PyTorch",
    overlayColor: "overlay2 pink lighten-4",
    overlayDesc: ` I'm introduced to this library in my applied machine learning
    class and I love that we have pre-trained models. Check out my
    Costa's vs Anna's hummingbird classifier!`,
  },
  {
    imageUrl:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2d/Tensorflow_logo.svg/718px-Tensorflow_logo.svg.png",
    imageAlt: "TensorFlow",
    overlayColor: "overlay2 deep-purple lighten-4",
    overlayDesc: `The MIT machine learning open class uses TensorFlow. I find that
    it wasn't hard to pick it up with PyTorch experience but
    TensorFlow does have better documentation.`,
  },
  {
    imageUrl:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/1280px-React-icon.svg.png",
    imageAlt: "React",
    overlayColor: "overlay2 red accent-1",
    overlayDesc: `I regret not learning about this framework sooner! Now I'm
    writing this site in React because that's how much I love it.`,
  },
  {
    imageUrl:
      "https://ih1.redbubble.net/image.738129642.6518/raf,750x1000,075,t,FFFFFF:97ab1c12de.jpg",
    imageAlt: "Unix Command",
    overlayColor: "overlay2 blue accent-1",
    overlayDesc: `All the command line and SSH into school server in computer
    science classes pays off.`,
  },
  {
    imageUrl:
      "https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/97_Docker_logo_logos-512.png",
    imageAlt: "Docker",
    overlayColor: "overlay2 purple accent-1",
    overlayDesc: `I use Docker with my student design team and I love how it
    speeds up the testing process and helps with dependency
    management. I'm still a newbie at it but I plan to learn more
    about it.`,
  },
  {
    imageUrl:
      "https://verbose-equals-true.gitlab.io/django-postgres-vue-gitlab-ecs/django.jpg",
    imageAlt: "Django",
    overlayColor: "overlay2 pink accent-1",
    overlayDesc: `This is the first web framework I'm exposed to and it was also
    through working with the UAS team. I have a project idea coming
    up and I plan to use Django as my backend.`,
  },
  {
    imageUrl:
      "https://cdn.shortpixel.ai/client/q_glossy,ret_img,w_502,h_518/https://keytotech.com/wp-content/uploads/2019/05/firebase.png",
    imageAlt: "Firebase",
    overlayColor: "overlay2 light-blue accent-1",
    overlayDesc: `I checked out a project based tutorial combining Firebase and
    React and proceeded to use it for a slack clone and a hackathon project. Definitely
    my go to NoSQL database.`,
  },
  {
    imageUrl: "https://cdn.freebiesupply.com/logos/thumbs/2x/flask-logo.png",
    imageAlt: "Flask",
    overlayColor: "overlay2 red accent-1",
    overlayDesc: `If I want a less complex Python web framework than Django Flask
    would be my choice. I used it in my women in stem api hackathon project, as well 
    as my ML car classification project where I serve the ML prediction over a simple API.`,
  },
  {
    imageUrl: "https://colab.research.google.com/img/colab_favicon_256px.png",
    imageAlt: "Google Collab",
    overlayColor: "overlay2 purple accent-1",
    overlayDesc: `I love the Linux VM and GPUs for ML model training, thank you
    Google for the free resources and credits!`,
  },
  {
    imageUrl:
      "https://cdn.iconscout.com/icon/free/png-512/google-cloud-2038785-1721675.png",
    imageAlt: "Google Cloud",
    overlayColor: "overlay2 cyan accent-1",
    overlayDesc: `I hosted the backend my first ML webapp here and I'm happy that Google Cloud can handle the
    big model.`,
  },
  {
    imageUrl: "https://authy.com/wp-content/uploads/npm-logo.png",
    imageAlt: "npm",
    overlayColor: "overlay2 green accent-1",
    overlayDesc: `Same story with Git: npm was like magic to me when I first
    started using it and now I cannot do without it. Props to the
    open source community! (Would like to contribute in the future)`,
  },
  {
    imageUrl: "https://miro.medium.com/max/512/1*fVBL9mtLJmHIH6YpU7WvHQ.png",
    imageAlt: "Postman",
    overlayColor: "overlay2 red accent-1",
    overlayDesc: `Great for API testing!`,
  },
  {
    imageUrl: "https://www.netlify.com/img/press/logos/logomark.png",
    imageAlt: "Netlify",
    overlayColor: "overlay2 indigo accent-1",
    overlayDesc: `This website is hosted by Netlify!`,
  },
  {
    imageUrl: "https://www.selenium.dev/images/selenium_logo_square_green.png",
    imageAlt: "Selenium",
    overlayColor: "overlay2 amber accent-1",
    overlayDesc: `I used Selenium to buil a simple shopping bot and later an image
    scraping program.`,
  },
  {
    imageUrl:
      "https://1000logos.net/wp-content/uploads/2020/08/Visual-Studio-Logo.png",
    imageAlt: "Visual Studio",
    overlayColor: "overlay2 teal accent-1",
    overlayDesc: `This was the IDE I used in first year in C programming. Now I
    just use Valgrind and GDB in Visual Studio and forgo the print
    statements.`,
  },
  {
    imageUrl:
      "https://gradle.org/images/gradle-knowledge-graph-logo.png?20170228",
    imageAlt: "Gradle",
    overlayColor: "overlay2 purple lighten-4",
    overlayDesc: `I used it for automated building writing Java code. I learned to
    configure dependencies, build and test procedures with it.`,
  },
  {
    imageUrl:
      "https://i1.wp.com/orion42.net/wp-content/uploads/2019/06/Matlab-Logo.png?fit=698%2C702",
    imageAlt: "MATLAB",
    overlayColor: "overlay2 lime accent-1",
    overlayDesc: `The all powerful tool for mathematicians and engineers that I
    wish I had the time to use more of. It helped when I was
    learning linear algebra and I went to a presentation about
    training ML model with MATLAB.`,
  },
  {
    imageUrl:
      "https://www.logolynx.com/images/logolynx/1d/1d12643eaacd5b3183eae12407bf4891.jpeg",
    imageAlt: "GDB",
    overlayColor: "overlay2 indigo accent-1",
    overlayDesc: `Trusted (although dreary) tool for debugging assembly and C
    languages. I do try to avoid using GDB in C with Valgrind.`,
  },
  {
    imageUrl:
      "https://images.g2crowd.com/uploads/product/image/social_landscape/social_landscape_7ee4293a8aaf4ebae71f9f8dd996e1d5/valgrind.png",
    imageAlt: "Valgrind",
    overlayColor: "overlay2 light-green accent-1",
    overlayDesc: `Hands down the only thing saving me from core dump errors and
    memory leaks.`,
  },
  {
    imageUrl:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/IntelliJ_IDEA_Icon.svg/768px-IntelliJ_IDEA_Icon.svg.png",
    imageAlt: "IntelliJ",
    overlayColor: "overlay2 red lighten-4",
    overlayDesc:
      "I used this first term in second year as my IDE for Java. IntelliJ provides smooth integration with Gradle.",
  },
  {
    imageUrl: "https://avatars.githubusercontent.com/u/874086?s=280&v=4",
    imageAlt: "JUnit",
    overlayColor: "overlay2 lime lighten-4",
    overlayDesc: "Favourite for unit testing with Java.",
  },
  {
    imageUrl:
      "https://raw.githubusercontent.com/mike-lischke/vscode-antlr4/master/misc/antlr-logo.png",
    imageAlt: "ANTLR",
    overlayColor: "overlay2 blue lighten-4",
    overlayDesc: ` Parsers are amazing! I did several assignments involving ANTLR
    parser and wrote a parse tree from scratch in one of them!`,
  },
  {
    imageUrl:
      "https://www.jackenhack.com/wp-content/uploads/2020/01/Quartus_prime_icon.png",
    imageAlt: "Quartus",
    overlayColor: "overlay2 red accent-1",
    overlayDesc: `Along with simulation in ModelSim, these two tools carried me
    through Verilog labs and proficiency tests. Not shown is the
    Intel FPGA Monitor Program which made debugging ARM assembly
    possible for me.`,
  },
];
